import React from 'react'
import PropTypes from 'prop-types'
import { SortDirection } from 'react-virtualized'
import { Icon, SortIcon } from 'src/components'
import { SelectAllIconAction } from 'src/components/buttons'
import { CounterBadge } from 'src/components/indicators'
import styles from './TableHeader.scss'

const TableHeader = ({
  dataKey,
  disableSort,
  label,
  sortBy,
  sortDirection,
  data,
  checkable,
  disabled,
  action,
  columnData,
}) => (
  <div className={styles.container}>
    {!disableSort && (
      <span className={`fa-layers ${styles.sort}`}>
        <Icon opacity={0.2} icon={SortIcon} />
        {sortBy === dataKey && (
          <Icon opacity={0.8} icon={sortDirection === SortDirection.ASC ? 'sort-up' : 'sort-down'} />
        )}
      </span>
    )}
    <span className={styles.label}>{label}</span>
    {checkable && (
      <CounterBadge size=".75rem" count={checkable.getValue({ columnData }).length} color="secondary">
        <SelectAllIconAction
          disabled={disabled}
          data={data.map(rowData => checkable.getItem({ rowData }))}
          value={checkable.getValue({ columnData })}
          onChange={checkable.getSetter({ columnData })}
        />
      </CounterBadge>
    )}
    {action}
  </div>
)

TableHeader.propTypes = {
  dataKey: PropTypes.string,
  disableSort: PropTypes.bool,
  label: PropTypes.node,
  action: PropTypes.node,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string,
  columnData: PropTypes.object,
  data: PropTypes.array,
  checkable: PropTypes.object,
  disabled: PropTypes.bool,
}

export default TableHeader
